// © Microsoft Corporation. All rights reserved.
import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { TreeItemTemplate as template } from "@microsoft/fast-foundation";
import { HamburgerMenuItem } from "./hamburger-menu-item";
import { HamburgerMenuItemStyles as styles } from "./hamburger-menu-item.styles";
/**
 * @public
 */
let MsftHamburgerMenuItem = class MsftHamburgerMenuItem extends HamburgerMenuItem {
};
MsftHamburgerMenuItem = __decorate([
    customElement({
        name: "msft-hamburger-menu-item",
        template,
        styles,
    })
], MsftHamburgerMenuItem);
export { MsftHamburgerMenuItem };
